import type {
  TRequestStage,
  TVehicleType
} from '@/shared/types/leasing-request.types';

import type { TRequestKind, TRequestStatus } from '../types/request.types';

export const ARCHIVE_REQUEST_STATUS_CODES = ['declined'] as const;

// Ключ подписи и цветовой тон бейджа статуса
export const REQUEST_STATUS_META: Record<
  TRequestStatus,
  { label: string; tone: 'purple' | 'blue' | 'green' | 'red' }
> = {
  signing: { label: 'requests.status.signing', tone: 'purple' },
  review: { label: 'requests.status.review', tone: 'blue' },
  approved: { label: 'requests.status.approved', tone: 'blue' },
  active: { label: 'requests.status.active', tone: 'green' },
  rejected: { label: 'requests.status.rejected', tone: 'red' }
};

// Ключ подписи типа карточки (заявка / договор)
export const REQUEST_KIND_LABELS: Record<TRequestKind, string> = {
  request: 'requests.kind.request',
  contract: 'requests.kind.contract'
};

export const VEHICLE_TYPE_LABELS = {
  new: 'requests.vehicleType.new',
  used: 'requests.vehicleType.used'
} as const;

export const API_REQUEST_STATUS_TO_CARD_STATUS: Record<string, TRequestStatus> =
  {
    declined: 'rejected',
    waiting_of_financing: 'approved',
    awaiting_underwriter_decision: 'review',
    approved: 'approved',
    financed: 'active'
  };

export const API_REQUEST_STATUS_TO_STAGE: Record<string, TRequestStage> = {
  awaiting_underwriter_decision: 'decision',
  approved: 'decision',
  declined: 'decision',
  waiting_of_financing: 'signing'
};

export const resolveApiCardStatus = (statusCode: string): TRequestStatus =>
  API_REQUEST_STATUS_TO_CARD_STATUS[statusCode] ?? 'review';

export const resolveApiRequestStage = (statusCode: string): TRequestStage =>
  API_REQUEST_STATUS_TO_STAGE[statusCode] ?? 'decision';

export const resolveVehicleType = (condition?: string | null): TVehicleType => {
  if (!condition) {
    return 'new';
  }

  const normalizedCondition = condition.toLowerCase();

  if (normalizedCondition.includes('нов')) {
    return 'new';
  }

  return 'used';
};
